import { render, staticRenderFns } from "./info.vue?vue&type=template&id=3c3b3f42&scoped=true&"
import script from "./info.vue?vue&type=script&lang=js&"
export * from "./info.vue?vue&type=script&lang=js&"
import style0 from "./info.css?vue&type=style&index=0&id=3c3b3f42&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c3b3f42",
  null
  
)

export default component.exports